var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsOfUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    id: "checklist",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51,5h-7c0-1.1-0.9-2-2-2H22c-1.1,0-2,0.9-2,2h-7c-2.2,0-4,1.8-4,4v48c0,2.2,1.8,4,4,4h38c2.2,0,4-1.8,4-4V9 C55,6.8,53.2,5,51,5z M49,51h-5c-0.6,0-1,0.4-1,1v4H17c-1.1,0-2-0.9-2-2V12c0-1.1,0.9-2,2-2h4h22h4c1.1,0,2,0.9,2,2V51z M45,54.8 V53h2.2L45,54.8z M22,5h20v1v2H22V6V5z M53,57c0,1.1-0.9,2-2,2H13c-1.1,0-2-0.9-2-2V9c0-1.1,0.9-2,2-2h7v1h-3c-2.2,0-4,1.8-4,4v42 c0,2.2,1.8,4,4,4h27c0.2,0,0.5-0.1,0.6-0.2l6-5c0.3-0.2,0.4-0.5,0.4-0.8V12c0-2.2-1.8-4-4-4h-3V7h7c1.1,0,2,0.9,2,2V57z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22h6c.6 0 1-.4 1-1v-3.8l1.6-1.3c.5-.3.5-1 .2-1.4-.3-.5-1-.5-1.4-.2l-.5.4C24.8 14.3 24.5 14 24 14h-6c-.6 0-1 .4-1 1v6C17 21.6 17.4 22 18 22zM19 18v-2h4v.2l-1.9 1.5-.4-.4c-.4-.4-1-.4-1.4 0C19.1 17.5 19 17.8 19 18s.1.5.3.7l1 1c.2.2.4.3.7.3.2 0 .4-.1.6-.1l1.4-1.1V20h-2-2V18zM24 34h-6c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-6C25 34.4 24.6 34 24 34zM23 40h-4v-4h4V40z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17H27c-.6 0-1 .4-1 1s.4 1 1 1h18c.6 0 1-.4 1-1S45.6 17 45 17zM45 27H27c-.6 0-1 .4-1 1s.4 1 1 1h18c.6 0 1-.4 1-1S45.6 27 45 27zM45 37H27c-.6 0-1 .4-1 1s.4 1 1 1h18c.6 0 1-.4 1-1S45.6 37 45 37z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6,25.9c0.5-0.3,0.5-1,0.2-1.4c-0.3-0.5-1-0.5-1.4-0.2l-0.5,0.4C24.8,24.3,24.5,24,24,24h-6c-0.6,0-1,0.4-1,1v6 c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1v-3.8L26.6,25.9z M23,30h-2h-2v-2v-2h4v0.2l-1.9,1.5l-0.4-0.4c-0.4-0.4-1-0.4-1.4,0 C19.1,27.5,19,27.8,19,28s0.1,0.5,0.3,0.7l1,1c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.4-0.1,0.6-0.1l1.4-1.1V30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsOfUse);
export default __webpack_public_path__ + "static/media/terms_of_use.b63f332780feedf9506c600b83080733.svg";
export { ForwardRef as ReactComponent };